/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/browser'
export default icon
